import { render, staticRenderFns } from "./InventoriesCompanyLocationsTable.vue?vue&type=template&id=0f2a982e&"
import script from "./InventoriesCompanyLocationsTable.vue?vue&type=script&lang=ts&"
export * from "./InventoriesCompanyLocationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports